import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const createCardEulaAPI = (params) => {
  return api.sendPost(endpoints.CREATE_CARD_EULA, params);
};

export const cloneCardEulaAPI = (params) => {
  return api.sendPost(endpoints.CLONE_CARD_EULA, params);
};

export const deleteCardEulaAPI = (params) => {
  return api.sendPost(endpoints.DELETE_CARD_EULA, params);
};

export const getCardEulaShortDetail = (params) => {
  return api.sendGet(
    `/api/payment/get-card-eula-short-detail?CardEulaId=${params}`
  );
};

export const getCardEula = (params) => {
  return api.sendPost(endpoints.GET_CARD_EULA, params);
};

export const getCardEulaList = (params) => {
  return api.sendPost(endpoints.GET_CARD_EULA_DETAIL_GRID, params);
};

export const getProductsForCapture = (params) => {
  return api.sendPost(endpoints.GET_PRODUCTS_FOR_CAPTURE, params);
};

export const fetchProductActiveMaking = (params) => {
  return api.sendPost(endpoints.MAKING_PRODUCT_ACTIVE, params);
};

export const validateActiveProduct = (params) => {
  return api.sendPost(endpoints.VALIDATE_ACTIVE_PRODUCT, params);
};

export const sendProductToCapture = (params) => {
  return api.sendPost(endpoints.SEND_PRODUCT_TO_CAPTURE, params);
};

export const chargeSavedMemberCard = (params) => {
  return api.sendPost(endpoints.CHARGE_SAVED_MEMBER_CARD, params);
};

export const downloadUserCardHistory = (params) => {
  return api.sendPost(endpoints.EXPORT_CARD_HISTORY_USER, params);
};
